module.exports = __webpack_public_path__ + "img/logo.ce3a63e1.png";